import { createSelector } from 'reselect';

import { calcDiscount, isNumber } from '@utils/number';
import { getRouterState } from '@shared/selectors';
import getShopAPI from '@core/reducers/shop/selectors/getShop';
import getGlobalDiscountsWeekly from '@core/reducers/menu/selectors/getGlobalDiscountsWeekly';

import getPropFromModule from './getPropFromModule';

const getProduct = createSelector(
  getShopAPI,
  getGlobalDiscountsWeekly,
  state => getPropFromModule(state, 'product'),
  getRouterState,
  (shop, weeklyDiscount, product, routerProduct) => {
    if (!shop || !product) {
      return routerProduct?.product?.name
        ? { ...routerProduct.product, loading: true }
        : null;
    }

    const productJs = product.toJS();

    if (isNumber(productJs?.maxQuantity) && productJs.maxQuantity <= 0)
      delete productJs.maxQuantity;

    if (!productJs.applyDiscount || weeklyDiscount?.amount === 0) {
      return productJs;
    }

    const priceWithDiscount = calcDiscount(
      weeklyDiscount?.amount,
      productJs.applyDiscount,
      productJs.price,
    );

    return { ...productJs, priceWithDiscount };
  },
);

export const getProductId = createSelector(getProduct, product => product?.id);

export const getSectionProduct = createSelector(
  getProduct,
  product => product?.section,
);

export default getProduct;
